import { useEffect, useState } from "react";
import api from "../api/api";
import TableRow from "./TableRow";
import { useSocket } from "../context/SocketProvider";

export default function Table({ onMobileTrade, onRowClick, selectedCoinId }) {
  const [coinSummaryData, setCoinSummaryData] = useState([]);
  const socket = useSocket();

  useEffect(() => {
    async function fetchCoinData() {
      try {
        const response = await api.get('/market/summary');
        setCoinSummaryData(response.data);
      } catch (err) {
        console.error('Error fetching coin data:', err);
      }
    }
    fetchCoinData();
    if (!socket) return;
    const handleCoinDataUpdated = () => {
      fetchCoinData();
    }
    socket.on('coinDataUpdated', handleCoinDataUpdated);
    return () => {
      socket.off('coinDataUpdated', handleCoinDataUpdated);
    };
  }, [socket]);
  return (
    <table className="w-full lg:w-3/5">
      <thead className="sticky top-0 bg-white z-10">
        <tr className="text-right border-b border-stone-300">
          <th className="text-left py-6 lg:pl-4">Coin</th>
          <th className="py-6">Price</th>
          <th className="py-6">24h %</th>
          <th className="hidden lg:table-cell py-6">Market Cap</th>
          <th className="hidden lg:table-cell py-6 lg:pr-4">24h Volume</th>
          <th className="lg:hidden"></th>
        </tr>
      </thead>
      <tbody>
        {coinSummaryData.map((coinSummary) => (
          <TableRow
            key={coinSummary.id}
            id={coinSummary.id}
            image={coinSummary.image}
            name={coinSummary.name}
            symbol={coinSummary.symbol}
            price={Number(coinSummary.current_price)}
            change_percentage_24h={Number(coinSummary.price_change_percentage_24h)}
            marketCap={Number(coinSummary.market_cap)}
            volume={Number(coinSummary.total_volume)}
            onMobileTrade={onMobileTrade}
            onRowClick={onRowClick}
            selectedCoinId={selectedCoinId}
          />
        ))}
      </tbody>
    </table>
  );
}